// extracted by mini-css-extract-plugin
module.exports = {"blur":"coreLayout-module--blur--2PqBe","coreLayout":"coreLayout-module--coreLayout--2ItJA","mainLayout":"coreLayout-module--mainLayout--1A3bn"};